<script lang="ts">
import type { VariantProps } from 'tailwind-variants';
import type { PageContentVariants } from './PageContent.vue';
import { tv } from 'tailwind-variants';

export const pageLayoutListing = tv({
	base: 'flex-col',
	variants: {
		bottomPadding: {
			true: 'pb-10',
			false: '',
		},
	},
});

export type PageLayoutListingVariants = VariantProps<typeof pageLayoutListing>;

interface PageLayoutListingProps {
	gutter?: boolean;
	showBottomPadding?: PageLayoutListingVariants['bottomPadding'];
	width?: PageContentVariants['width'];
}
</script>

<script setup lang="ts">
import { computed } from 'vue';
import PageContent from './PageContent.vue';

const {
	gutter = true,
	showBottomPadding = true,
	width = 'full-bleed',
} = defineProps<PageLayoutListingProps>();

const gutters = computed(() => gutter ? 'page' : 'none');
const className = computed(() => pageLayoutListing({ bottomPadding: showBottomPadding }));
</script>

<template>
	<PageContent
		:width
		:gutters
		vertical-padding="none"
		fill
		:class="className"
	>
		<slot />
	</PageContent>
</template>
